import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { AutoComplete } from 'primereact/autocomplete';

import { ModelOfStock } from 'src/database';
import LoadingScreen from '../../components/LoadingScreen';

import { useListUnitysController } from 'src/controllers/Unitys/ListUnitysController';
import { useListStocksController } from '../../controllers/Stocks/ListStocksController';
import { Toast } from 'primereact/toast';
import useIntersectionObserver from 'src/components/IntersectionObserver/useIntersectionObserver';
import { PulseLoader } from 'react-spinners';

interface filteredFieldProps {
	label: string;
	value?: string;
}

const StocksList: React.FC = () => {
	const { getStockListController, handleStockListController } = useListStocksController();
	const { getUnityListController } = useListUnitysController();

	const [valueUnity, setValueUnity] = useState('');
	const [filteredUnity, setFilteredUnity] = useState<filteredFieldProps[]>([{ label: '', value: '' }]);

	const searchUnitys = (event: any) => {
		let filteredUnitys;
		if (!event.query.trim().length) {
			filteredUnitys = [...unitys];
		} else {
			filteredUnitys = unitys.filter(unity => {
				return unity.label.toLowerCase().includes(event.query.toLowerCase());
			});
		}

		setFilteredUnity(filteredUnitys);
	};

	const unitys = getUnityListController.AllUnitysData.map(unity => {
		return { label: unity.NOME, value: unity.ID };
	});

	if (getStockListController.loading) {
		return <LoadingScreen />;
	}

	const actionBodyTemplate = (stock: ModelOfStock) => {
		return (
			<React.Fragment>
				<Button
					icon='pi pi-pencil'
					className='p-button-rounded p-button-text p-button-success p-mr-2'
					onClick={() => handleStockListController.openEditDialog(stock)}
				/>
				<Button
					icon='pi pi-trash'
					className='p-button-rounded p-button-text p-button-danger'
					onClick={() => handleStockListController.openDeleteDialog(stock)}
				/>
			</React.Fragment>
		);
	};

	const editStockDialogFooter = (
		<React.Fragment>
			<Button
				label='Cancelar'
				icon='pi pi-times'
				className='p-button-text'
				onClick={handleStockListController.closeEditDialog}
			/>
			<Button
				type='submit'
				label='Salvar'
				icon='pi pi-check'
				className='p-button-text'
				onClick={() => {
					getStockListController.formik.handleSubmit();
				}}
			/>
		</React.Fragment>
	);

	const deleteStockDialogFooter = (
		<React.Fragment>
			<Button
				label='Não'
				icon='pi pi-times'
				className='p-button-text'
				onClick={handleStockListController.closeDeleteDialog}
			/>
			<Button
				label='Sim'
				icon='pi pi-check'
				className='p-button-text'
				onClick={() => {
					getStockListController.selectedStock &&
						handleStockListController.removeStock(getStockListController.selectedStock);
				}}
			/>
		</React.Fragment>
	);

	const leftStockToolbar = () => {
		return (
			<Link to='/stockForm'>
				<Button label='Cadastrar estoque' icon='pi pi-plus' className='p-button-success p-mr-2' />
			</Link>
		);
	};

	const Loader: React.FC = ({ children }) => {
		const divRef: any = useRef<HTMLDivElement | null>(null);

		const [isVisible] = useIntersectionObserver({
			elementRef: divRef,
		});

		if (isVisible && !getStockListController.maxData && !getStockListController.loadingRows) {
			handleStockListController.setRows(getStockListController.rows + 20);
		}

		return (
			<div
				ref={divRef}
				style={{
					minHeight: '5px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}>
				{children}
			</div>
		);
	};

	return (
		<div>
			<Toast ref={getStockListController.toast} />
			<div className='p-card p-p-4 datatable-container'>
				<Toolbar className='p-mb-4' left={leftStockToolbar}></Toolbar>
				<DataTable
					className='p-datatable-sm responsive-table'
					dataKey='ID'
					autoLayout
					scrollHeight={'100%'}
					scrollable
					rowHover
					value={getStockListController.stocksData}>
					<Column field='NOME' header='Estoque'></Column>
					<Column field='NOME_ORGAOUNIDADE' header='Unidade'></Column>
					<Column body={actionBodyTemplate} bodyStyle={{ textAlign: 'right' }}></Column>
				</DataTable>
				{/* // ** removido o loader porque estava emitindo um erro na renderização
				 */}
				{/* <Loader>
					{!getStockListController.maxData ? (
						getStockListController.loadingRows ? (
							<PulseLoader color='#0388e5' size={8} />
						) : (
							<></>
						)
					) : (
						'Lista completa'
					)}
				</Loader> */}
			</div>

			<Dialog
				className='p-fluid dropdown-visible'
				style={{ width: '450px' }}
				visible={getStockListController.editDialog}
				onHide={handleStockListController.closeEditDialog}
				onShow={() => {
					getStockListController.formik.setValues(getStockListController.selectedStock);
					setValueUnity(getStockListController.selectedStock.NOME_ORGAOUNIDADE || '');
				}}
				footer={editStockDialogFooter}
				header={`Editar estoque ${getStockListController.selectedStock?.NOME}`}
				modal>
				{getStockListController.loadingEdit ? <LoadingScreen color='#0388e5' /> : <></>}
				<div className='p-field p-col-12'>
					<label htmlFor='description'>Nome</label>
					<InputText
						id='name'
						type='text'
						value={getStockListController.formik.values.NOME}
						onChange={getStockListController.formik.handleChange('NOME')}
						required
					/>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getStockListController.formik.touched.NOME && getStockListController.formik.errors.NOME,
							'popup-form-inactive': !(
								getStockListController.formik.touched.NOME && getStockListController.formik.errors.NOME
							),
						})}>
						{getStockListController.formik.errors.NOME}
					</div>
				</div>
				<div className='p-field p-col-12 datatable-container'>
					<label htmlFor='unidade'>Unidade</label>
					<AutoComplete
						id='unidade'
						value={valueUnity}
						field='label'
						placeholder='Buscar...'
						onChange={e => {
							setValueUnity(e.value);
							getStockListController.formik.setFieldValue(
								'ORGAOUNIDADE',
								filteredUnity.find(unity => {
									return valueUnity.toLowerCase() === unity.label.toLowerCase();
								})?.value || '',
							);
						}}
						onSelect={e => {
							setValueUnity(e.value.label);
							getStockListController.formik.setFieldValue('ORGAOUNIDADE', e.value.value);
						}}
						suggestions={filteredUnity}
						completeMethod={searchUnitys}
						dropdown
						dropdownMode='current'
						minLength={2}
						delay={0}
					/>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getStockListController.formik.touched.ORGAOUNIDADE &&
								getStockListController.formik.errors.ORGAOUNIDADE,
							'popup-form-inactive': !(
								getStockListController.formik.touched.ORGAOUNIDADE &&
								getStockListController.formik.errors.ORGAOUNIDADE
							),
						})}>
						{getStockListController.formik.errors.ORGAOUNIDADE}
					</div>
				</div>
			</Dialog>

			<Dialog
				style={{ width: '450px' }}
				visible={getStockListController.deleteDialog}
				onHide={handleStockListController.closeDeleteDialog}
				footer={deleteStockDialogFooter}
				header='Remover estoque'
				modal>
				<div className='confirmation-content'>
					<i className='pi pi-exclamation-triangle p-mr-3' style={{ fontSize: '2rem' }} />
					{getStockListController.selectedStock && (
						<span>
							Você tem certeza que deseja remover o estoque{' '}
							<b>{getStockListController.selectedStock.NOME}</b>?
						</span>
					)}
				</div>
			</Dialog>
		</div>
	);
};

export default StocksList;
